import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class PortsService {

  constructor(private globalService: GlobalService) {}

  get(idMachine: string): Observable<any> {
    return this.globalService.post('/SP-GetPortsByDevice/', { idMachine });
  }

  test(): Observable<any> {
    return this.globalService.get('/SP-TestPorts/');
  }

  update(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdatePorts/', data);
  }

  reset(data: any): Observable<any> {
    return this.globalService.post('/SP-ResetPorts/', data);
  }

  resetQuotaSmsById(id: string): Observable<any> {
    return this.globalService.post('/SP-ResetSmsQuota/', { id });
  }

  getAllPortsSlotsStatus(): Observable<any> {
    return this.globalService.get('/SP-TestStatusPorts/');
  }

  toggleStrategiesStatus(): Observable<any> {
    return this.globalService.get('/SP-ToggleStrategieStatus/');
  }

  executeSendSms(): Observable<any> {
    return this.globalService.get('/SP-SendSms/');
  }

  executeReceptionSms(): Observable<any> {
    return this.globalService.get('/SP-ReceptionSms/');
  }

  resetQuotaHeure(): Observable<any> {
    return this.globalService.post('/SP-ResetQuotaJH/', { type: 'heure' });
  }

  resetQuotaJour(): Observable<any> {
    return this.globalService.post('/SP-ResetQuotaJH/', { type: 'jour' });
  }

  resetDevice(idMachine: string): Observable<any> {
    return this.globalService.post('/SP-ResetQuotaJH/', { type: 'reset', idMachine: idMachine });
  }

  executePhoneNumberRecovery(data: any): Observable<any> {
    return this.globalService.post('/SP-GetPhoneNumber/', data);
  }

  getSlotsByDevice(idMachine: string): Observable<any> {
    return this.globalService.post('/SP-GetSlotsByDevice/', { idMachine });
  }

}
